<ng-container *ngIf="airQuantitySearchForm && maxTravellers">
    <h2 class="form-title">{{ wording.travellers }}</h2>
    <form [formGroup]="airQuantitySearchForm">
        <number [disabled]="disabled" [labelPosition]="labelPosition" [showPlusAndMinus]="!disabled"
                [fieldConfig]="{
                min: 0,
                max: maxTravellers[eAirSearchFields.adult],
                label: wording.adult,
                fixed: 0,
                formControlName: eAirSearchFields.adult,
                disabled: disabled,
                formGroup: airQuantitySearchForm}"></number>
        <number [disabled]="disabled" [labelPosition]="labelPosition" [showPlusAndMinus]="!disabled"
                [fieldConfig]="{
                min: 0,
                max: maxTravellers[eAirSearchFields.child],
                label: wording.child,
                fixed: 0,
                formControlName: eAirSearchFields.child,
                disabled: disabled,
                formGroup: airQuantitySearchForm}"></number>
        <number [disabled]="disabled" [labelPosition]="labelPosition" [showPlusAndMinus]="!disabled"
                [fieldConfig]="{
                min: 0,
                max: maxTravellers[eAirSearchFields.infant],
                label: wording.infant,
                fixed: 0,
                disabled: disabled,
                formControlName: eAirSearchFields.infant,
                formGroup: airQuantitySearchForm}"></number>
    </form>
</ng-container>
